<template>
    <card>
        <div class="text-center my-4">
            <i class="nch--icon fas fa-cart-arrow-down mb-2"></i>
            <h1 class="font-weight-medium mb-0">{{$t('cart.empty')}}</h1>
            <p>{{$t('cart.empty_message')}}</p>
            <button class="btn" :style="[$bgColor(color.primary), { color: color.secondary }]" @click="goBack">{{$t('cart.empty_button')}}</button>
        </div>
    </card>

</template>

<script>
import Card from '../../argon/components/Cards/Card'

export default {
    name: 'CartEmpty',
    components: {
        Card
    },
    computed: {
        color() {
            return this.$store.getters.COLOR
        },
    },
    methods: {
        goBack() {
            this.$loading.show()
            window.location.replace('/plans')
        }
    }
}
</script>

<style scoped>
.nch--icon {
    font-size: 5em
}
</style>
